module.exports = __webpack_public_path__ + "static/media/Litecoin.35a7bc37.svg";